import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "dashboard-area pt-120 mb-120" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { class: "row g-lg-4 gy-5 mb-90" }
const _hoisted_4 = { class: "col-lg-9" }
const _hoisted_5 = { class: "applied-job-area" }
const _hoisted_6 = { class: "table-wrapper" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "table-title-filter" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "section-title" }, [
    /*#__PURE__*/_createElementVNode("h5", null, "Applied Jobs:")
  ])
], -1)
const _hoisted_8 = {
  key: 0,
  class: "title"
}
const _hoisted_9 = {
  key: 1,
  class: "eg-table table category-table mb-30"
}
const _hoisted_10 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", null, "Job Title"),
    /*#__PURE__*/_createElementVNode("th", null, "Apply Date"),
    /*#__PURE__*/_createElementVNode("th", null, "Company"),
    /*#__PURE__*/_createElementVNode("th", null, "Status")
  ])
], -1)
const _hoisted_11 = { key: 0 }
const _hoisted_12 = { colspan: "6" }
const _hoisted_13 = { "data-label": "Job Title" }
const _hoisted_14 = { class: "company-info" }
const _hoisted_15 = { class: "company-details" }
const _hoisted_16 = { class: "top" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("img", {
  src: "/assets/images/icon/location.svg",
  alt: ""
}, null, -1)
const _hoisted_18 = { class: "d-flex flex-wrap" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createElementVNode("img", {
    src: "/assets/images/icon/arrow2.svg",
    width: "10",
    alt: ""
  }),
  /*#__PURE__*/_createElementVNode("span", { class: "title ms-2" }, "Salary:")
], -1)
const _hoisted_20 = { style: {"width":"9rem !important"} }
const _hoisted_21 = { "data-label": "Apply Job" }
const _hoisted_22 = { "data-label": "Company" }
const _hoisted_23 = {
  class: "view-btn",
  href: "company-details.html",
  style: {"text-overflow":"initial"}
}
const _hoisted_24 = { "data-label": "Status" }
const _hoisted_25 = { class: "create-profile-btn" }
const _hoisted_26 = {
  href: "javascript:void(0)",
  class: "primry-btn-1 user-btn-custom"
}
const _hoisted_27 = { class: "pagination-table-info" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_user_menu = _resolveComponent("user-menu")!
  const _component_ProgressSpinner = _resolveComponent("ProgressSpinner")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_Paginator = _resolveComponent("Paginator")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_user_menu),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _hoisted_7,
              (!_ctx.isLoading && _ctx.jobApplications.length == 0)
                ? (_openBlock(), _createElementBlock("h4", _hoisted_8, "No Record Found..."))
                : _createCommentVNode("", true),
              (_ctx.jobApplications.length > 0)
                ? (_openBlock(), _createElementBlock("table", _hoisted_9, [
                    _hoisted_10,
                    _createElementVNode("tbody", null, [
                      (_ctx.isLoading)
                        ? (_openBlock(), _createElementBlock("tr", _hoisted_11, [
                            _createElementVNode("td", _hoisted_12, [
                              _createVNode(_component_ProgressSpinner)
                            ])
                          ]))
                        : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_ctx.jobApplications, (application) => {
                            return (_openBlock(), _createElementBlock("tr", {
                              key: application.id
                            }, [
                              _createElementVNode("td", _hoisted_13, [
                                _createElementVNode("div", _hoisted_14, [
                                  _createElementVNode("div", _hoisted_15, [
                                    _createElementVNode("div", _hoisted_16, [
                                      _createElementVNode("h6", null, [
                                        _createVNode(_component_router_link, {
                                          to: _ctx.getJobDetail(application.job.job_key, application.job.job_slug)
                                        }, {
                                          default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(application.job.job_title), 1)
                                          ]),
                                          _: 2
                                        }, 1032, ["to"])
                                      ])
                                    ]),
                                    _createElementVNode("div", null, [
                                      _hoisted_17,
                                      _createTextVNode(" " + _toDisplayString(application.job.location), 1)
                                    ]),
                                    _createElementVNode("div", _hoisted_18, [
                                      _hoisted_19,
                                      _createElementVNode("span", _hoisted_20, _toDisplayString(application.job.salary_range), 1)
                                    ])
                                  ])
                                ])
                              ]),
                              _createElementVNode("td", _hoisted_21, _toDisplayString(application.applied_on), 1),
                              _createElementVNode("td", _hoisted_22, [
                                _createElementVNode("a", _hoisted_23, _toDisplayString(application.job.company), 1)
                              ]),
                              _createElementVNode("td", _hoisted_24, [
                                _createElementVNode("div", _hoisted_25, [
                                  _createElementVNode("a", _hoisted_26, _toDisplayString(application.status_name), 1)
                                ])
                              ])
                            ]))
                          }), 128))
                    ])
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_27, [
                _createVNode(_component_Paginator, {
                  first: _ctx.currentPage,
                  "onUpdate:first": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.currentPage) = $event)),
                  rows: _ctx.rowsPerPage,
                  totalRecords: _ctx.totalPages,
                  onPage: _ctx.handlePageChange
                }, null, 8, ["first", "rows", "totalRecords", "onPage"])
              ])
            ])
          ])
        ])
      ])
    ])
  ]))
}